<template>
  <b-container>
     <b-card>
      <FormReportingChannel
        :id="id"
        :requestForm="requestForm">
      </FormReportingChannel>
      <div class="mt-1 mb-2 print:hidden">
        <div class="flex justify-end">
          <b-button
            v-permission="`reporting_channel_handling.handling`"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1 float-right"
            @click="handlingForm()">
              {{$t('handling_form')}}
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            class="mt-1 mr-1 float-right"
            @click="$router.push('/reporting-channel')">
              {{$t('back')}}
          </b-button>
        </div>
      </div>
     </b-card>
  </b-container>
</template>

<script>

import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BTable,
  BButton,
  VBTooltip
} from 'bootstrap-vue'

import ReportingChannelFormHandlingService from '@/services/api/reporting-channel/ReportingChannelFormHandlingService'

import FormReportingChannel from './FormReportingChannel'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    //
    FormReportingChannel,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    id: null,
    requestForm: null,
    services: {
      handling: null
    },
  }),
  methods: {
    getData(id) {
      const promisses = []
      this.$vs.loading()
      promisses.push(
        this.services.handling.read(id).then(
          data => {
            this.requestForm = data;
          },
          error => {
            this.$vs.loading.close()
          }
        ).finally(() => {
            this.$vs.loading.close()
          }
        )
      )//End promisses

      Promise.all(promisses).then(() => {
        this.$vs.loading.close()
        console.log('all load...')
      })
    },
    handlingForm() {
      this.$router.push(`/reporting-channel/${this.id}/handling`)
    },
  },
  mounted() {
    if(this.id){
      this.getData(this.id)
    }
  },
  beforeMount() {
     //Services
    this.services.handling = ReportingChannelFormHandlingService.build(this.$vs)

  }
}
</script>
